import { default as indexA6CkBJ9gD7Meta } from "/__w/landing-page/landing-page/pages/about-us/index.vue?macro=true";
import { default as indexEM211K2zS6Meta } from "/__w/landing-page/landing-page/pages/accommodations/[id]/booked/index.vue?macro=true";
import { default as indexSvvPPaDEsYMeta } from "/__w/landing-page/landing-page/pages/accommodations/[id]/confirm-booking/index.vue?macro=true";
import { default as room_45typesL6iEgJeU6EMeta } from "/__w/landing-page/landing-page/pages/accommodations/[id]/confirm-booking/room-types.vue?macro=true";
import { default as indexzRSeNrpqWQMeta } from "/__w/landing-page/landing-page/pages/accommodations/[id]/index.vue?macro=true";
import { default as indexkBQnKs7X59Meta } from "/__w/landing-page/landing-page/pages/accommodations/[id]/payment/index.vue?macro=true";
import { default as indexOh8KX4Gi5EMeta } from "/__w/landing-page/landing-page/pages/accommodations/[id]/success/index.vue?macro=true";
import { default as indexo8MiGLJIwpMeta } from "/__w/landing-page/landing-page/pages/accommodations/index.vue?macro=true";
import { default as indexQWTfd6C61KMeta } from "/__w/landing-page/landing-page/pages/account/index.vue?macro=true";
import { default as indexOaCdqv0UnnMeta } from "/__w/landing-page/landing-page/pages/activities/[id]/booked/index.vue?macro=true";
import { default as indexn4yh0WphGFMeta } from "/__w/landing-page/landing-page/pages/activities/[id]/confirm-booking/index.vue?macro=true";
import { default as indexREkxgbTVd0Meta } from "/__w/landing-page/landing-page/pages/activities/[id]/index.vue?macro=true";
import { default as indexa4TrHMsfftMeta } from "/__w/landing-page/landing-page/pages/activities/[id]/payment/index.vue?macro=true";
import { default as indexpAvpVVXWYrMeta } from "/__w/landing-page/landing-page/pages/activities/[id]/success/index.vue?macro=true";
import { default as indexXHXZeRuJA5Meta } from "/__w/landing-page/landing-page/pages/activities/index.vue?macro=true";
import { default as index0tBvRQXCDyMeta } from "/__w/landing-page/landing-page/pages/auction-frogs/index.vue?macro=true";
import { default as indexzF0FolmnEzMeta } from "/__w/landing-page/landing-page/pages/auction-frogs/terms-and-conditions/index.vue?macro=true";
import { default as forgot_45passwordjkAmvAWroOMeta } from "/__w/landing-page/landing-page/pages/auth/forgot-password.vue?macro=true";
import { default as register6FpZsYOtmdMeta } from "/__w/landing-page/landing-page/pages/auth/register.vue?macro=true";
import { default as reset_45passwordotBAwKl35NMeta } from "/__w/landing-page/landing-page/pages/auth/reset-password.vue?macro=true";
import { default as validate_45emailc3uObsadH8Meta } from "/__w/landing-page/landing-page/pages/auth/validate-email.vue?macro=true";
import { default as validate_45phone3ATy3zcvWrMeta } from "/__w/landing-page/landing-page/pages/auth/validate-phone.vue?macro=true";
import { default as indexUcDTjTUthwMeta } from "/__w/landing-page/landing-page/pages/bye/index.vue?macro=true";
import { default as indexivNvwp6wYtMeta } from "/__w/landing-page/landing-page/pages/certifications/index.vue?macro=true";
import { default as indexbqsb0L0EAjMeta } from "/__w/landing-page/landing-page/pages/community/hotel/index.vue?macro=true";
import { default as indexzjPi8hX5lZMeta } from "/__w/landing-page/landing-page/pages/community/index.vue?macro=true";
import { default as index92tu2maGXBMeta } from "/__w/landing-page/landing-page/pages/community/restaurant/index.vue?macro=true";
import { default as indexi4V1335gCDMeta } from "/__w/landing-page/landing-page/pages/community/tour_guide/index.vue?macro=true";
import { default as indexr8bCY4aDPWMeta } from "/__w/landing-page/landing-page/pages/contact-us/index.vue?macro=true";
import { default as index4lH3SXID4XMeta } from "/__w/landing-page/landing-page/pages/cookies/index.vue?macro=true";
import { default as indexwj1zLhUy00Meta } from "/__w/landing-page/landing-page/pages/destinations/[id]/index.vue?macro=true";
import { default as indexTw4dUykH0bMeta } from "/__w/landing-page/landing-page/pages/destinations/index.vue?macro=true";
import { default as _91id_93qmCNAQrSWoMeta } from "/__w/landing-page/landing-page/pages/digital-postcards/[id].vue?macro=true";
import { default as indexpweGtC1DZ8Meta } from "/__w/landing-page/landing-page/pages/digital-postcards/index.vue?macro=true";
import { default as indexChFVAVuhdIMeta } from "/__w/landing-page/landing-page/pages/donatella/index.vue?macro=true";
import { default as indexQafDbdlOJGMeta } from "/__w/landing-page/landing-page/pages/donatella2/index.vue?macro=true";
import { default as indexvUGuDSmPdXMeta } from "/__w/landing-page/landing-page/pages/experiences/[id]/booked/index.vue?macro=true";
import { default as indexF25A07E93PMeta } from "/__w/landing-page/landing-page/pages/experiences/[id]/confirm-booking/index.vue?macro=true";
import { default as indexsI9aLfH4jdMeta } from "/__w/landing-page/landing-page/pages/experiences/[id]/index.vue?macro=true";
import { default as indexWSuVgpJLkcMeta } from "/__w/landing-page/landing-page/pages/experiences/[id]/payment/index.vue?macro=true";
import { default as indexEo7nBp6iW4Meta } from "/__w/landing-page/landing-page/pages/experiences/[id]/rsvp/index.vue?macro=true";
import { default as indexMeHK8O0GvGMeta } from "/__w/landing-page/landing-page/pages/experiences/[id]/success/index.vue?macro=true";
import { default as indexS953jUJuR6Meta } from "/__w/landing-page/landing-page/pages/experiences/index.vue?macro=true";
import { default as indexy1Aky82SwkMeta } from "/__w/landing-page/landing-page/pages/faqs/index.vue?macro=true";
import { default as index6WHDQYTyszMeta } from "/__w/landing-page/landing-page/pages/guides/[id]/index.vue?macro=true";
import { default as indexBG1OrYfAh6Meta } from "/__w/landing-page/landing-page/pages/index.vue?macro=true";
import { default as index1m9AgrkoIDMeta } from "/__w/landing-page/landing-page/pages/inspirations/index.vue?macro=true";
import { default as index4zY1LNoHnkMeta } from "/__w/landing-page/landing-page/pages/itineraries/[id]/index.vue?macro=true";
import { default as indexGCmocRIYBGMeta } from "/__w/landing-page/landing-page/pages/login/index.vue?macro=true";
import { default as indexJg0sy8vZBDMeta } from "/__w/landing-page/landing-page/pages/memberships/[id]/confirm-booking/index.vue?macro=true";
import { default as indexIU8HRxbYz0Meta } from "/__w/landing-page/landing-page/pages/memberships/[id]/payment/index.vue?macro=true";
import { default as index2pprAm8xsrMeta } from "/__w/landing-page/landing-page/pages/memberships/[id]/success/index.vue?macro=true";
import { default as index6rzOv8EJrkMeta } from "/__w/landing-page/landing-page/pages/memberships/index.vue?macro=true";
import { default as indexTF9FEMbTYBMeta } from "/__w/landing-page/landing-page/pages/my-membership/index.vue?macro=true";
import { default as indexyqmPn2aJLZMeta } from "/__w/landing-page/landing-page/pages/nft-wallet/[id]/index.vue?macro=true";
import { default as indexaPcDpJEtkEMeta } from "/__w/landing-page/landing-page/pages/nft-wallet/index.vue?macro=true";
import { default as indexLGbIQECZXzMeta } from "/__w/landing-page/landing-page/pages/press/index.vue?macro=true";
import { default as indexVezIDxuwf7Meta } from "/__w/landing-page/landing-page/pages/privacy-policy/index.vue?macro=true";
import { default as indexW0ASR23meFMeta } from "/__w/landing-page/landing-page/pages/register/[coupon]/index.vue?macro=true";
import { default as onboardingerAIK19KvTMeta } from "/__w/landing-page/landing-page/pages/register/[coupon]/onboarding.vue?macro=true";
import { default as validate_45emailJ9BBQdZbdTMeta } from "/__w/landing-page/landing-page/pages/register/[coupon]/validate-email.vue?macro=true";
import { default as validate_45phoneUk5yAqgob2Meta } from "/__w/landing-page/landing-page/pages/register/[coupon]/validate-phone.vue?macro=true";
import { default as indexbouK4vAWecMeta } from "/__w/landing-page/landing-page/pages/reservations/[id]/index.vue?macro=true";
import { default as indexHdA7AEhMwIMeta } from "/__w/landing-page/landing-page/pages/reservations/index.vue?macro=true";
import { default as indexNvc2zxVxMhMeta } from "/__w/landing-page/landing-page/pages/restaurants/[id]/booked/index.vue?macro=true";
import { default as index4hsbEjdSw5Meta } from "/__w/landing-page/landing-page/pages/restaurants/[id]/confirm-booking/index.vue?macro=true";
import { default as indexibC4Sej6SrMeta } from "/__w/landing-page/landing-page/pages/restaurants/[id]/index.vue?macro=true";
import { default as indexGjN0hJ4VesMeta } from "/__w/landing-page/landing-page/pages/restaurants/[id]/payment/index.vue?macro=true";
import { default as index9Kin83lMQXMeta } from "/__w/landing-page/landing-page/pages/restaurants/[id]/success/index.vue?macro=true";
import { default as indexMVOkvPSCanMeta } from "/__w/landing-page/landing-page/pages/restaurants/index.vue?macro=true";
import { default as index5y77e46riYMeta } from "/__w/landing-page/landing-page/pages/search/index.vue?macro=true";
import { default as indexOC9AjZTltHMeta } from "/__w/landing-page/landing-page/pages/services/[id]/booked/index.vue?macro=true";
import { default as indexwpusWWMt6hMeta } from "/__w/landing-page/landing-page/pages/services/[id]/confirm-booking/index.vue?macro=true";
import { default as indexjxJDKZ8uOMMeta } from "/__w/landing-page/landing-page/pages/services/[id]/index.vue?macro=true";
import { default as index4DvMohuKQ2Meta } from "/__w/landing-page/landing-page/pages/services/[id]/payment/index.vue?macro=true";
import { default as indexpKDjQYVXMaMeta } from "/__w/landing-page/landing-page/pages/services/[id]/success/index.vue?macro=true";
import { default as indexnKr0d54UCaMeta } from "/__w/landing-page/landing-page/pages/services/index.vue?macro=true";
import { default as indexXupFJLC689Meta } from "/__w/landing-page/landing-page/pages/sms-policy/index.vue?macro=true";
import { default as indexAiIdpMP3aAMeta } from "/__w/landing-page/landing-page/pages/social-responsibility/index.vue?macro=true";
import { default as indexRRqsEvTm5nMeta } from "/__w/landing-page/landing-page/pages/sporsonship-opportunities/index.vue?macro=true";
import { default as indexvaVHIaF6AeMeta } from "/__w/landing-page/landing-page/pages/suggestions/index.vue?macro=true";
import { default as indexFyFQhQCIMQMeta } from "/__w/landing-page/landing-page/pages/surveys/guide/index.vue?macro=true";
import { default as indexIztRmgCvLvMeta } from "/__w/landing-page/landing-page/pages/surveys/traveller/index.vue?macro=true";
import { default as indexEWLHdA3KyCMeta } from "/__w/landing-page/landing-page/pages/terms-and-conditions/index.vue?macro=true";
import { default as indexMbUrXPxpCUMeta } from "/__w/landing-page/landing-page/pages/tours/[id]/booked/index.vue?macro=true";
import { default as indextkTT7K6XlfMeta } from "/__w/landing-page/landing-page/pages/tours/[id]/confirm-booking/index.vue?macro=true";
import { default as indexu2q6NgycJxMeta } from "/__w/landing-page/landing-page/pages/tours/[id]/index.vue?macro=true";
import { default as index7a2ceSnCAJMeta } from "/__w/landing-page/landing-page/pages/tours/[id]/payment/index.vue?macro=true";
import { default as index0AkeSiK03CMeta } from "/__w/landing-page/landing-page/pages/tours/[id]/success/index.vue?macro=true";
import { default as indexopbspky32tMeta } from "/__w/landing-page/landing-page/pages/tours/index.vue?macro=true";
import { default as indexbVyPgQ22PnMeta } from "/__w/landing-page/landing-page/pages/welcome/index.vue?macro=true";
import { default as indexgTL0xzM27uMeta } from "/__w/landing-page/landing-page/pages/your-itineraries/[id]/booked/index.vue?macro=true";
import { default as index3maNUXaO9IMeta } from "/__w/landing-page/landing-page/pages/your-itineraries/[id]/flights/confirm-booking/index.vue?macro=true";
import { default as indexc3VNcEuLDdMeta } from "/__w/landing-page/landing-page/pages/your-itineraries/[id]/flights/index.vue?macro=true";
import { default as indexxJAGDecfUuMeta } from "/__w/landing-page/landing-page/pages/your-itineraries/[id]/flights/payment/index.vue?macro=true";
import { default as index5kadJIWQKGMeta } from "/__w/landing-page/landing-page/pages/your-itineraries/[id]/flights/success/index.vue?macro=true";
import { default as indexqtm2giEJgeMeta } from "/__w/landing-page/landing-page/pages/your-itineraries/[id]/index.vue?macro=true";
import { default as indexg1sUHYAKrrMeta } from "/__w/landing-page/landing-page/pages/your-itineraries/[id]/payment/index.vue?macro=true";
import { default as indexTkIV8RD9HMMeta } from "/__w/landing-page/landing-page/pages/your-itineraries/[id]/success/index.vue?macro=true";
import { default as indexikuCWdka1aMeta } from "/__w/landing-page/landing-page/pages/your-itineraries/index.vue?macro=true";
import { default as newdsOdUhYWnFMeta } from "/__w/landing-page/landing-page/pages/your-itineraries/new.vue?macro=true";
export default [
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/__w/landing-page/landing-page/pages/about-us/index.vue")
  },
  {
    name: "accommodations-id-booked",
    path: "/accommodations/:id()/booked",
    meta: indexEM211K2zS6Meta || {},
    component: () => import("/__w/landing-page/landing-page/pages/accommodations/[id]/booked/index.vue")
  },
  {
    name: "accommodations-id-confirm-booking",
    path: "/accommodations/:id()/confirm-booking",
    component: () => import("/__w/landing-page/landing-page/pages/accommodations/[id]/confirm-booking/index.vue")
  },
  {
    name: "accommodations-id-confirm-booking-room-types",
    path: "/accommodations/:id()/confirm-booking/room-types",
    meta: room_45typesL6iEgJeU6EMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/accommodations/[id]/confirm-booking/room-types.vue")
  },
  {
    name: "accommodations-id",
    path: "/accommodations/:id()",
    component: () => import("/__w/landing-page/landing-page/pages/accommodations/[id]/index.vue")
  },
  {
    name: "accommodations-id-payment",
    path: "/accommodations/:id()/payment",
    meta: indexkBQnKs7X59Meta || {},
    component: () => import("/__w/landing-page/landing-page/pages/accommodations/[id]/payment/index.vue")
  },
  {
    name: "accommodations-id-success",
    path: "/accommodations/:id()/success",
    meta: indexOh8KX4Gi5EMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/accommodations/[id]/success/index.vue")
  },
  {
    name: "accommodations",
    path: "/accommodations",
    component: () => import("/__w/landing-page/landing-page/pages/accommodations/index.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: indexQWTfd6C61KMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/account/index.vue")
  },
  {
    name: "activities-id-booked",
    path: "/activities/:id()/booked",
    meta: indexOaCdqv0UnnMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/activities/[id]/booked/index.vue")
  },
  {
    name: "activities-id-confirm-booking",
    path: "/activities/:id()/confirm-booking",
    component: () => import("/__w/landing-page/landing-page/pages/activities/[id]/confirm-booking/index.vue")
  },
  {
    name: "activities-id",
    path: "/activities/:id()",
    component: () => import("/__w/landing-page/landing-page/pages/activities/[id]/index.vue")
  },
  {
    name: "activities-id-payment",
    path: "/activities/:id()/payment",
    meta: indexa4TrHMsfftMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/activities/[id]/payment/index.vue")
  },
  {
    name: "activities-id-success",
    path: "/activities/:id()/success",
    meta: indexpAvpVVXWYrMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/activities/[id]/success/index.vue")
  },
  {
    name: "activities",
    path: "/activities",
    component: () => import("/__w/landing-page/landing-page/pages/activities/index.vue")
  },
  {
    name: "auction-frogs",
    path: "/auction-frogs",
    component: () => import("/__w/landing-page/landing-page/pages/auction-frogs/index.vue")
  },
  {
    name: "auction-frogs-terms-and-conditions",
    path: "/auction-frogs/terms-and-conditions",
    component: () => import("/__w/landing-page/landing-page/pages/auction-frogs/terms-and-conditions/index.vue")
  },
  {
    name: "auth-forgot-password",
    path: "/auth/forgot-password",
    component: () => import("/__w/landing-page/landing-page/pages/auth/forgot-password.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    component: () => import("/__w/landing-page/landing-page/pages/auth/register.vue")
  },
  {
    name: "auth-reset-password",
    path: "/auth/reset-password",
    component: () => import("/__w/landing-page/landing-page/pages/auth/reset-password.vue")
  },
  {
    name: "auth-validate-email",
    path: "/auth/validate-email",
    component: () => import("/__w/landing-page/landing-page/pages/auth/validate-email.vue")
  },
  {
    name: "auth-validate-phone",
    path: "/auth/validate-phone",
    component: () => import("/__w/landing-page/landing-page/pages/auth/validate-phone.vue")
  },
  {
    name: "bye",
    path: "/bye",
    component: () => import("/__w/landing-page/landing-page/pages/bye/index.vue")
  },
  {
    name: "certifications",
    path: "/certifications",
    component: () => import("/__w/landing-page/landing-page/pages/certifications/index.vue")
  },
  {
    name: "community-hotel",
    path: "/community/hotel",
    component: () => import("/__w/landing-page/landing-page/pages/community/hotel/index.vue")
  },
  {
    name: "community",
    path: "/community",
    component: () => import("/__w/landing-page/landing-page/pages/community/index.vue")
  },
  {
    name: "community-restaurant",
    path: "/community/restaurant",
    component: () => import("/__w/landing-page/landing-page/pages/community/restaurant/index.vue")
  },
  {
    name: "community-tour_guide",
    path: "/community/tour_guide",
    component: () => import("/__w/landing-page/landing-page/pages/community/tour_guide/index.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    component: () => import("/__w/landing-page/landing-page/pages/contact-us/index.vue")
  },
  {
    name: "cookies",
    path: "/cookies",
    component: () => import("/__w/landing-page/landing-page/pages/cookies/index.vue")
  },
  {
    name: "destinations-id",
    path: "/destinations/:id()",
    component: () => import("/__w/landing-page/landing-page/pages/destinations/[id]/index.vue")
  },
  {
    name: "destinations",
    path: "/destinations",
    component: () => import("/__w/landing-page/landing-page/pages/destinations/index.vue")
  },
  {
    name: "digital-postcards-id",
    path: "/digital-postcards/:id()",
    meta: _91id_93qmCNAQrSWoMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/digital-postcards/[id].vue")
  },
  {
    name: "digital-postcards",
    path: "/digital-postcards",
    meta: indexpweGtC1DZ8Meta || {},
    component: () => import("/__w/landing-page/landing-page/pages/digital-postcards/index.vue")
  },
  {
    name: "donatella",
    path: "/donatella",
    meta: indexChFVAVuhdIMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/donatella/index.vue")
  },
  {
    name: "donatella2",
    path: "/donatella2",
    meta: indexQafDbdlOJGMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/donatella2/index.vue")
  },
  {
    name: "experiences-id-booked",
    path: "/experiences/:id()/booked",
    meta: indexvUGuDSmPdXMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/experiences/[id]/booked/index.vue")
  },
  {
    name: "experiences-id-confirm-booking",
    path: "/experiences/:id()/confirm-booking",
    component: () => import("/__w/landing-page/landing-page/pages/experiences/[id]/confirm-booking/index.vue")
  },
  {
    name: "experiences-id",
    path: "/experiences/:id()",
    component: () => import("/__w/landing-page/landing-page/pages/experiences/[id]/index.vue")
  },
  {
    name: "experiences-id-payment",
    path: "/experiences/:id()/payment",
    meta: indexWSuVgpJLkcMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/experiences/[id]/payment/index.vue")
  },
  {
    name: "experiences-id-rsvp",
    path: "/experiences/:id()/rsvp",
    component: () => import("/__w/landing-page/landing-page/pages/experiences/[id]/rsvp/index.vue")
  },
  {
    name: "experiences-id-success",
    path: "/experiences/:id()/success",
    meta: indexMeHK8O0GvGMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/experiences/[id]/success/index.vue")
  },
  {
    name: "experiences",
    path: "/experiences",
    component: () => import("/__w/landing-page/landing-page/pages/experiences/index.vue")
  },
  {
    name: "faqs",
    path: "/faqs",
    component: () => import("/__w/landing-page/landing-page/pages/faqs/index.vue")
  },
  {
    name: "guides-id",
    path: "/guides/:id()",
    component: () => import("/__w/landing-page/landing-page/pages/guides/[id]/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/__w/landing-page/landing-page/pages/index.vue")
  },
  {
    name: "inspirations",
    path: "/inspirations",
    component: () => import("/__w/landing-page/landing-page/pages/inspirations/index.vue")
  },
  {
    name: "itineraries-id",
    path: "/itineraries/:id()",
    component: () => import("/__w/landing-page/landing-page/pages/itineraries/[id]/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/__w/landing-page/landing-page/pages/login/index.vue")
  },
  {
    name: "memberships-id-confirm-booking",
    path: "/memberships/:id()/confirm-booking",
    meta: indexJg0sy8vZBDMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/memberships/[id]/confirm-booking/index.vue")
  },
  {
    name: "memberships-id-payment",
    path: "/memberships/:id()/payment",
    meta: indexIU8HRxbYz0Meta || {},
    component: () => import("/__w/landing-page/landing-page/pages/memberships/[id]/payment/index.vue")
  },
  {
    name: "memberships-id-success",
    path: "/memberships/:id()/success",
    meta: index2pprAm8xsrMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/memberships/[id]/success/index.vue")
  },
  {
    name: "memberships",
    path: "/memberships",
    component: () => import("/__w/landing-page/landing-page/pages/memberships/index.vue")
  },
  {
    name: "my-membership",
    path: "/my-membership",
    meta: indexTF9FEMbTYBMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/my-membership/index.vue")
  },
  {
    name: "nft-wallet-id",
    path: "/nft-wallet/:id()",
    component: () => import("/__w/landing-page/landing-page/pages/nft-wallet/[id]/index.vue")
  },
  {
    name: "nft-wallet",
    path: "/nft-wallet",
    component: () => import("/__w/landing-page/landing-page/pages/nft-wallet/index.vue")
  },
  {
    name: "press",
    path: "/press",
    component: () => import("/__w/landing-page/landing-page/pages/press/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/__w/landing-page/landing-page/pages/privacy-policy/index.vue")
  },
  {
    name: "register-coupon",
    path: "/register/:coupon()",
    meta: indexW0ASR23meFMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/register/[coupon]/index.vue")
  },
  {
    name: "register-coupon-onboarding",
    path: "/register/:coupon()/onboarding",
    meta: onboardingerAIK19KvTMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/register/[coupon]/onboarding.vue")
  },
  {
    name: "register-coupon-validate-email",
    path: "/register/:coupon()/validate-email",
    meta: validate_45emailJ9BBQdZbdTMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/register/[coupon]/validate-email.vue")
  },
  {
    name: "register-coupon-validate-phone",
    path: "/register/:coupon()/validate-phone",
    meta: validate_45phoneUk5yAqgob2Meta || {},
    component: () => import("/__w/landing-page/landing-page/pages/register/[coupon]/validate-phone.vue")
  },
  {
    name: "reservations-id",
    path: "/reservations/:id()",
    meta: indexbouK4vAWecMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/reservations/[id]/index.vue")
  },
  {
    name: "reservations",
    path: "/reservations",
    meta: indexHdA7AEhMwIMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/reservations/index.vue")
  },
  {
    name: "restaurants-id-booked",
    path: "/restaurants/:id()/booked",
    meta: indexNvc2zxVxMhMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/restaurants/[id]/booked/index.vue")
  },
  {
    name: "restaurants-id-confirm-booking",
    path: "/restaurants/:id()/confirm-booking",
    component: () => import("/__w/landing-page/landing-page/pages/restaurants/[id]/confirm-booking/index.vue")
  },
  {
    name: "restaurants-id",
    path: "/restaurants/:id()",
    component: () => import("/__w/landing-page/landing-page/pages/restaurants/[id]/index.vue")
  },
  {
    name: "restaurants-id-payment",
    path: "/restaurants/:id()/payment",
    meta: indexGjN0hJ4VesMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/restaurants/[id]/payment/index.vue")
  },
  {
    name: "restaurants-id-success",
    path: "/restaurants/:id()/success",
    meta: index9Kin83lMQXMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/restaurants/[id]/success/index.vue")
  },
  {
    name: "restaurants",
    path: "/restaurants",
    component: () => import("/__w/landing-page/landing-page/pages/restaurants/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/__w/landing-page/landing-page/pages/search/index.vue")
  },
  {
    name: "services-id-booked",
    path: "/services/:id()/booked",
    meta: indexOC9AjZTltHMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/services/[id]/booked/index.vue")
  },
  {
    name: "services-id-confirm-booking",
    path: "/services/:id()/confirm-booking",
    component: () => import("/__w/landing-page/landing-page/pages/services/[id]/confirm-booking/index.vue")
  },
  {
    name: "services-id",
    path: "/services/:id()",
    component: () => import("/__w/landing-page/landing-page/pages/services/[id]/index.vue")
  },
  {
    name: "services-id-payment",
    path: "/services/:id()/payment",
    meta: index4DvMohuKQ2Meta || {},
    component: () => import("/__w/landing-page/landing-page/pages/services/[id]/payment/index.vue")
  },
  {
    name: "services-id-success",
    path: "/services/:id()/success",
    meta: indexpKDjQYVXMaMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/services/[id]/success/index.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/__w/landing-page/landing-page/pages/services/index.vue")
  },
  {
    name: "sms-policy",
    path: "/sms-policy",
    component: () => import("/__w/landing-page/landing-page/pages/sms-policy/index.vue")
  },
  {
    name: "social-responsibility",
    path: "/social-responsibility",
    component: () => import("/__w/landing-page/landing-page/pages/social-responsibility/index.vue")
  },
  {
    name: "sporsonship-opportunities",
    path: "/sporsonship-opportunities",
    component: () => import("/__w/landing-page/landing-page/pages/sporsonship-opportunities/index.vue")
  },
  {
    name: "suggestions",
    path: "/suggestions",
    component: () => import("/__w/landing-page/landing-page/pages/suggestions/index.vue")
  },
  {
    name: "surveys-guide",
    path: "/surveys/guide",
    component: () => import("/__w/landing-page/landing-page/pages/surveys/guide/index.vue")
  },
  {
    name: "surveys-traveller",
    path: "/surveys/traveller",
    component: () => import("/__w/landing-page/landing-page/pages/surveys/traveller/index.vue")
  },
  {
    name: "terms-and-conditions",
    path: "/terms-and-conditions",
    component: () => import("/__w/landing-page/landing-page/pages/terms-and-conditions/index.vue")
  },
  {
    name: "tours-id-booked",
    path: "/tours/:id()/booked",
    meta: indexMbUrXPxpCUMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/tours/[id]/booked/index.vue")
  },
  {
    name: "tours-id-confirm-booking",
    path: "/tours/:id()/confirm-booking",
    component: () => import("/__w/landing-page/landing-page/pages/tours/[id]/confirm-booking/index.vue")
  },
  {
    name: "tours-id",
    path: "/tours/:id()",
    component: () => import("/__w/landing-page/landing-page/pages/tours/[id]/index.vue")
  },
  {
    name: "tours-id-payment",
    path: "/tours/:id()/payment",
    meta: index7a2ceSnCAJMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/tours/[id]/payment/index.vue")
  },
  {
    name: "tours-id-success",
    path: "/tours/:id()/success",
    meta: index0AkeSiK03CMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/tours/[id]/success/index.vue")
  },
  {
    name: "tours",
    path: "/tours",
    component: () => import("/__w/landing-page/landing-page/pages/tours/index.vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    component: () => import("/__w/landing-page/landing-page/pages/welcome/index.vue")
  },
  {
    name: "your-itineraries-id-booked",
    path: "/your-itineraries/:id()/booked",
    meta: indexgTL0xzM27uMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/your-itineraries/[id]/booked/index.vue")
  },
  {
    name: "your-itineraries-id-flights-confirm-booking",
    path: "/your-itineraries/:id()/flights/confirm-booking",
    component: () => import("/__w/landing-page/landing-page/pages/your-itineraries/[id]/flights/confirm-booking/index.vue")
  },
  {
    name: "your-itineraries-id-flights",
    path: "/your-itineraries/:id()/flights",
    component: () => import("/__w/landing-page/landing-page/pages/your-itineraries/[id]/flights/index.vue")
  },
  {
    name: "your-itineraries-id-flights-payment",
    path: "/your-itineraries/:id()/flights/payment",
    meta: indexxJAGDecfUuMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/your-itineraries/[id]/flights/payment/index.vue")
  },
  {
    name: "your-itineraries-id-flights-success",
    path: "/your-itineraries/:id()/flights/success",
    meta: index5kadJIWQKGMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/your-itineraries/[id]/flights/success/index.vue")
  },
  {
    name: "your-itineraries-id",
    path: "/your-itineraries/:id()",
    component: () => import("/__w/landing-page/landing-page/pages/your-itineraries/[id]/index.vue")
  },
  {
    name: "your-itineraries-id-payment",
    path: "/your-itineraries/:id()/payment",
    meta: indexg1sUHYAKrrMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/your-itineraries/[id]/payment/index.vue")
  },
  {
    name: "your-itineraries-id-success",
    path: "/your-itineraries/:id()/success",
    meta: indexTkIV8RD9HMMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/your-itineraries/[id]/success/index.vue")
  },
  {
    name: "your-itineraries",
    path: "/your-itineraries",
    meta: indexikuCWdka1aMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/your-itineraries/index.vue")
  },
  {
    name: "your-itineraries-new",
    path: "/your-itineraries/new",
    meta: newdsOdUhYWnFMeta || {},
    component: () => import("/__w/landing-page/landing-page/pages/your-itineraries/new.vue")
  }
]